import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, signal } from '@angular/core';

type LegendState = 'active' | 'inactive';

const legendAnimations = [
  trigger('helpLegendToggler', [
    state(
      'inactive',
      style({
        transform: 'rotate(0deg)',
      }),
    ),
    state(
      'active',
      style({
        transform: 'rotate(360deg)',
      }),
    ),
    transition('* <=> *', animate('500ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  ]),
  trigger('helpLegendContainer', [
    state('inactive', style({ height: '0px', borderWidth: '0px' })),
    state('active', style({ height: '*', borderWidth: '1px' })),
    transition('active <=> inactive', animate('500ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  ]),
];

@Component({
  selector: 'app-overview-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss', '../overview.component.scss'],
  animations: legendAnimations,
  standalone: false,
})
export default class LegendComponent {
  readonly state = signal<LegendState>('inactive');

  getHelpButtonColor(): string {
    return this.state() === 'active' ? 'accent' : 'info';
  }

  toggleState(): void {
    this.state.set(this.state() === 'active' ? 'inactive' : 'active');
  }
}
